import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import NavBar from './NavBar';
import Panel from './Panel';
import Bottom from './Bottom';
import nowpayments from '../images/nowpayments.svg';
import axios from 'axios';
function Pay(props) {
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  var { state } = useLocation();
  //console.log('Message superAdmin ', superAdmin);

  // Function to handle back button click
  const handleBackButton = () => {
      // Navigate to the home page when the back button is clicked
      navigate('/pay');
  };

  useEffect(() => {
      // Listen for the 'popstate' event which is triggered when the back button is clicked
      window.addEventListener('popstate', handleBackButton);

      return () => {
          // Remove the event listener when the component is unmounted
          window.removeEventListener('popstate', handleBackButton);
      };
  }, []);

  const [statement, setStatement] = useState([]);
  const [payButtonUrl, setPayButtonUrl] = useState();
  const [paymentAmount, setPaymentAmount] = useState(300);//change minimal payment amount
  const [tokens, setTokens] = useState(55555);
  const [bonus, setBonus] = useState(0);
  const handleAmountChange = (event) => {
      let amount = parseFloat(event.target.value);
     //console.log('amount ',amount);
      
      let calculatedTokens = 0;
      let calculatedBonus = 0;
      const comission = state.values.comission/100;
      //const comission = 0.09;
      //console.log('comission ',comission)
      //if (amount <= 1000) { calculatedBonus = 0; } else
      //if (amount <= 5000) { calculatedBonus = 1; } else { calculatedBonus = 2; };
      calculatedTokens = amount/comission;
      //console.log('calculatedTokens ',calculatedTokens);
      setTokens(calculatedTokens);
      setBonus(calculatedBonus);
      //setPaymentAmount(isNaN(amount) ? 0 : amount);
      setPaymentAmount(isNaN(amount) ? 0 : amount);
    
  };
  const statementData = async () => {
    try {
      const res = await axios.post('/payment/statement', {
        user_code: state.values.user_code,
        agent_code: state.values.agent_code,
      });
      //console.log('response from statement:', res.data);
      setStatement(res.data);
    } catch (err) {
      //console.log(err.response.request.status);
      if (err.response.request.status === 400) {
        alert("statementData failed!");
      }
      if (err.response.request.status === 500) {
        alert("Internal Server Error!");
      }
    }
  };
  const payButton = async (paymentAmount) => {
    try {
      if (paymentAmount < 299) { alert(paymentAmount + 'USD is too small! Minimal payment amount is 300USD') }
      else {
        const res = await axios.post('/payment/pay', {
          user_code: state.values.user_code,
          agent_code: state.values.agent_code,
          price_amount: paymentAmount,
          price_currency: "usd",
        });
        //console.log('response from pay:', res.data.invoice_url);
        setPayButtonUrl(res.data.invoice_url);
      }
    } catch (err) {
      console.log(err.response.data.code);
    }
  };
  useEffect(() => {
    statementData();
    axios
      .post('/login', state.values)
      .then((res) => {
        if (res.data.length !== 0) {
          const values = res.data;
          navigate('/pay', { state: { values } });
        } else {
          alert('No record existed');
        }
      })
      .catch((err) => {
        console.log(err.response.request.status);
        if (err.response.request.status === 401) {
          alert('Invalid credentials');
        } else if (err.response.request.status === 404) {
          alert('User not found');
        } else if (err.response.request.status === 500) {
          alert('Internal Server Error');
        }
      });
  }, []);
  useEffect(() => {
    if (payButtonUrl) {
      const delay = 2000;
      const timer = setTimeout(() => {
        window.open(payButtonUrl, '_blank');
        //window.open(payButtonUrl, '_self');
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [payButtonUrl]);
  /*
  useEffect(() => {
    handleAmountChange(); // Call handleAmountChange when paymentAmount changes
  }, [paymentAmount]);
  */
  // Function to calculate the sum of "Price Currency" for finished payments
  const calculateSum = (payments) => {
    try {
      const finishedPayments = payments.filter((payment) => payment.payment_status === 'finished');
      //console.log('Finished Payments:', finishedPayments);

      const numericPayments = finishedPayments.filter((payment) => !isNaN(parseFloat(payment.price_amount)));
      //console.log('Numeric Payments:', numericPayments);

      const sum = numericPayments.reduce((acc, payment) => acc + parseFloat(payment.price_amount), 0);
      //console.log('Sum:', sum);

      return sum;
    } catch (error) {
      console.error('Error calculating sum:', error);
      return 0;
    }
  };


  return (
    <React.StrictMode>
      <div className="d-flex w-100 vh-100 justify-content-center align-items-start">
        <div className="d-flex w-10 vh-100 justify-content-center align-items-start"><NavBar state={state} /></div>
        <div className="d-grid w-90 vh-1000 p-2 rounded bg-white">
          <div className="d-flex w-100 vh-10 justify-content-center align-items-start"><Panel state={state} /></div>
          <h2>Payments.</h2>
          <div className="alert alert-info" style={{whiteSpace: 'pre-line', fontSize: '1.1em'}}>
            <h5>🎉 Launch with Highconnect – Now Enjoy <strong>6 Months with 0% GGR Commission!</strong></h5>
            <p>We're making it even easier for you to start your online gaming business — with <strong>zero GGR commission for 6 full months</strong>. Here's how it works:</p>
            <h6>💡 How It Works</h6>
            <strong>Option 1: Start with JILI (0% GGR for 6 Months – Free Setup)</strong>
            <ol>
              <li><strong>Start with JILI – 100% GGR-Free for 6 Months</strong><br/>Access 350+ JILI games instantly, including 2 free test credits, with zero commission for your first 6 months.</li>
              <li><strong>Integrate Gaming API & Website</strong><br/>We provide free website development and seamless API integration – no setup fees, no strings attached.</li>
              <li><strong>Run Traffic, Build Traction</strong><br/>Focus on growing your user base while we support you — all under 0% GGR for 6 months.</li>
              <li><strong>Month 7 Onward: GGR Starts at Just 6%</strong><br/>Your commission starts at 6%, and we activate 13 premium game providers including:<br/>
                <span style={{fontSize: '0.95em'}}>Pragmatic · Evoplay · PGSoft · Habanero · Booongo · Playson · CQ9 · DreamTech · TopTrend · Reelkingdom · Pragmaticliv</span>
              </li>
            </ol>
            <strong>Option 2: Start with All 13 Providers from Day One</strong>
            <ul>
              <li>Want full access from the beginning? You can start with all 13 premium providers right away.</li>
              <li>✅ <strong>Setup Fee:</strong> $0</li>
              <li>✅ <strong>Initial GGR Deposit:</strong> $300</li>
              <li>✅ <strong>Over 1,200 Premium Games Available Instantly</strong></li>
            </ul>
            <h6>💸 Smart Commission Model</h6>
            <p>After the GGR-free period, your rate starts at 6%, but it drops as your GGR grows:<br/>
            For every 100,000 USDT in monthly GGR, your rate drops by 1% – down to as low as 2%.</p>
            <h6>🚀 Ready to launch your gaming business with no commission pressure?</h6>
            <p>
              <strong>📞 Contact us now:</strong><br/>
              • Telegram: <a href="https://t.me/sr_alx" target="_blank" rel="noopener noreferrer">@sr_alx</a><br/>
              📢 Join our channel for updates & deals: <a href="https://t.me/api_casino777" target="_blank" rel="noopener noreferrer">https://t.me/api_casino777</a>
            </p>
          </div>
          <div className="row">
            <div className="form-control d-flex w-100 vh-20 justify-content-around align-items-start">
              <div className="mb-2">
                <label htmlFor="role"><strong>Currency:</strong></label>
                <span>{state.values.currency}</span>
              </div>
              <div className="mb-2">
                <label htmlFor="name"><strong>API Fee:</strong></label>
                <span>{state.values.comission}%</span>
              </div>
            </div>
            <div className="form-control d-flex w-100 vh-20 justify-content-around align-items-start">
            <div className="mb-2">
                <label htmlFor="role"><strong>Currency Rate (USD:{state.values.currency}):</strong></label>
                <span>1:{state.values.currency_rate}</span>
              </div>
              <div className="mb-2">
                <label htmlFor="name"><strong>Calculation:</strong></label>
                <span>100USD=100USD*{state.values.currency_rate}/({state.values.comission}/100)=1428.5714 tokens</span>
              </div>
          </div>
          </div>
          {/* Input field for entering payment amount */}
          <div className="gap-3 d-flex justify-content-around mt-4 p-3">
            <label htmlFor="paymentAmount" className="form-label">
              Enter Payment Amount:
            </label>
            <input
              type="number"
              className="form-control"
              id="paymentAmount"
              value={paymentAmount}
              onChange={(event)=>handleAmountChange(event)}
            />
            <button onClick={() => payButton(paymentAmount)} className='btn btn-success w-100 rounded-0 blinking-text'>Pay {paymentAmount}USD<br />Deposit amount {tokens} tokens{/*<br/>Bonus {bonus}%*/}</button>
          </div>
          {/* Buttons */}
          <div className="form-control ">Powered by <img src={nowpayments} alt="Powered by NowPayments" className="img-fluid" /> </div>
          
          <div>
          </div>
          <div>
            <div className="mb-2 justify-content-center align-items-start">User {state.values.name} Payments - Total: {calculateSum(statement.allPaymentsUser)} USD</div>
            <table className="mb-2 justify-content-center align-items-start">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Currency</th>
                  <th>Payment-ID</th>
                  <th>Status</th>
                  <th>Amount</th>
                  <th>Currency</th>
                  <th>Created</th>
                </tr>
              </thead>
              <tbody>
                {statement.allPaymentsUser?.map((payment) => (
                  <tr key={payment.id}>
                    <td>{payment.id}</td>
                    <td>{payment.pay_currency}</td>
                    <td>{payment.payment_id}</td>
                    <td>{payment.payment_status}</td>
                    <td>{payment.price_amount}</td>
                    <td>{payment.price_currency}</td>
                    <td>{new Date(payment.createdAt).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/** 
          {state.values.role==="user" ? (
                      <div>
                      <div className="mb-2 justify-content-center align-items-start">User {state.values.name} Payments - Total: {calculateSum(statement.allPaymentsUser)} USD</div>
                      <table className="mb-2 justify-content-center align-items-start">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Currency</th>
                            <th>Payment-ID</th>
                            <th>Status</th>
                            <th>Amount</th>
                            <th>Currency</th>
                            <th>Created</th>
                          </tr>
                        </thead>
                        <tbody>
                          {statement.allPaymentsUser?.map((payment) => (
                            <tr key={payment.id}>
                              <td>{payment.id}</td>
                              <td>{payment.pay_currency}</td>
                              <td>{payment.payment_id}</td>
                              <td>{payment.payment_status}</td>
                              <td>{payment.price_amount}</td>
                              <td>{payment.price_currency}</td>
                              <td>{payment.createdAt}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      </div>
          ) : (
            <div>
            <div className="mb-2 justify-content-center align-items-start">Agent {state.values.name} Payments - Total: {calculateSum(statement.allPaymentsAgent)} USD</div>
            <table className="mb-2 justify-content-center align-items-start">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Currency</th>
                  <th>Payment ID</th>
                  <th>Status</th>
                  <th>Amount</th>
                  <th>Price,Currency</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {statement.allPaymentsAgent?.map((payment) => (
                  <tr key={payment.id}>
                    <td>{payment.id}</td>
                    <td>{payment.pay_currency}</td>
                    <td>{payment.payment_id}</td>
                    <td>{payment.payment_status}</td>
                    <td>{payment.price_amount}</td>
                    <td>{payment.price_currency}</td>
                    <td>{payment.createdAt}</td>
                  </tr>
                ))}
              </tbody>
                </table> 
                </div>
          )}
**/}

          <Bottom />
        </div>
      </div>
    </React.StrictMode>
  );
}

export default Pay;
